var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 859,
    height: 753,
    viewBox: "0 0 859 753",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.38416,
    height: 538.092,
    transform: "matrix(-1 0 0 1 159.907 183.368)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43683,
    height: 518.367,
    transform: "matrix(-0.00291821 -0.999996 -0.999995 0.00314452 643.845 222.642)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.38416,
    height: 538.092,
    transform: "matrix(-1 0 0 1 216.658 183.368)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43683,
    height: 518.367,
    transform: "matrix(-0.00291821 -0.999996 -0.999995 0.00314452 644.017 281.551)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.38416,
    height: 538.092,
    transform: "matrix(-1 0 0 1 273.408 183.368)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43683,
    height: 518.367,
    transform: "matrix(-0.00291821 -0.999996 -0.999995 0.00314452 644.188 340.461)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.38416,
    height: 538.092,
    transform: "matrix(-1 0 0 1 330.159 183.368)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43683,
    height: 518.367,
    transform: "matrix(-0.00291821 -0.999996 -0.999995 0.00314452 644.361 399.37)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.38416,
    height: 538.092,
    transform: "matrix(-1 0 0 1 386.91 183.368)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43683,
    height: 518.367,
    transform: "matrix(-0.00291821 -0.999996 -0.999995 0.00314452 644.532 458.28)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.38416,
    height: 538.092,
    transform: "matrix(-1 0 0 1 443.66 183.368)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43683,
    height: 518.367,
    transform: "matrix(-0.00291821 -0.999996 -0.999995 0.00314452 644.704 517.189)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 1.38416,
    height: 538.092,
    transform: "matrix(-1 0 0 1 500.411 183.368)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43683,
    height: 518.367,
    transform: "matrix(-0.00291821 -0.999996 -0.999995 0.00314452 644.876 576.099)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 1.38416,
    height: 538.092,
    transform: "matrix(-1 0 0 1 557.161 183.368)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43683,
    height: 518.367,
    transform: "matrix(-0.00291821 -0.999996 -0.999995 0.00314452 645.048 635.009)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 1.38416,
    height: 538.092,
    transform: "matrix(-1 0 0 1 613.912 183.368)",
    fill: "#584843",
    fillOpacity: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 1.43683,
    height: 518.367,
    transform: "matrix(-0.00291821 -0.999996 -0.999995 0.00314452 645.22 693.919)",
    fill: "#584843",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    filter: "url(#filter0_f_63_150)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.5,
    cy: 481.599,
    rx: 324.5,
    ry: 271.4,
    fill: "#F0741A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_63_150",
    x: -209.892,
    y: 0.307129,
    width: 1068.78,
    height: 962.585,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 104.946,
    result: "effect1_foregroundBlur_63_150"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector1.42f6f93fdc07e303c32070b964af45ba.svg";
export { ForwardRef as ReactComponent };